<template>
  <div>
    <b-button
      v-b-modal.change-statuses-modal
      class="mt-1"
      v-text="$t('participationPanel.options.statusStations.change')"
    />

    <b-modal
      id="change-statuses-modal"
      size="lg"
      :title="$t('participationPanel.options.statusStations.popUpTitle')"
      hide-header-close
      :cancel-title="$t('cancel')"
      :ok-title="$t('save')"
      ok-variant="danger"
      @ok="handleSubmit"
    >
      <div class="modal__select-statuses d-flex justify-content-center">
        <div class="modal__select-statuses__active-statuses pr-3 mr-3">
          <strong>{{ $t('participationPanel.options.statusStations.currentSelection') }}</strong>
          <ul class="list-group list-group-flush">
            <li
              v-for="status in statuses"
              :key="status.value"
              class="list-group-item px-2"
            >
              <InlineChargingpointIcon
                :status="status.value"
              />
              {{ status.label }}
              <b-button
                variant="outline-danger"
                size="sm"
                class="ml-2 float-right"
                @click="() => removeStatus({ value: status.value })"
              >
                x
              </b-button>
              <b-button
                :variant="isCommentsEnabled(status.value) ? 'outline-success' : 'outline-secondary'"
                size="sm"
                class="ml-2 float-right"
                :title="isCommentsEnabled(status.value) ? $t('participationPanel.options.statusStations.commentsEnabled') : $t('participationPanel.options.statusStations.commentsDisabled')"
                @click="() => toggleComments(status.value)"
              >
                <i :class="['far', isCommentsEnabled(status.value) ? 'fa-comment' : 'fa-comment-slash']" />
              </b-button>
            </li>
          </ul>
        </div>

        <div class="modal__select-statuses__status-selector flex-grow-1">
          <strong>{{ $t('participationPanel.options.statusStations.addStatus') }}</strong>
          <p>{{ $t('participationPanel.options.statusStations.clickIcon') }}</p>
          <LocationStatusSelector
            :disabled-statuses="disabledStatuses"
            @select="handleInput"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import LocationStatusSelector from '@/components/admin/chargingpoints/LocationStatusSelector.vue'
import InlineChargingpointIcon from '@/components/common/InlineChargingpointIcon.vue'
import { mapGetters } from 'vuex'
import { CHARGINGPOINT_STATUS, CHARGINGPOINT_TYPE } from '../../../../shared/valueholders/chargingpoint-statuses'

export default {
  components: { InlineChargingpointIcon, LocationStatusSelector },
  props: {
    preselected: {
      type: Array,
      required: false,
      default: () => [],
    },
    preselectedCommentConfig: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selected: [],
      commentConfig: [],
      disabledStatuses: [CHARGINGPOINT_STATUS.ALERT, ...CHARGINGPOINT_TYPE.SUGGESTION, ...CHARGINGPOINT_TYPE.REJECTED],
    }
  },
  computed: {
    ...mapGetters('access', [
      'getActiveMunicipality',
    ]),
    statuses() {
      // should sorting be needed, this is the place
      return this.selected
    },
  },
  watch: {
    getActiveMunicipality() {
      this.init()
    },
  },
  mounted() {
    // reset on close
    this.$root.$on('bv::modal::hidden', () => {
      this.init()
    })
  },
  destroyed() {
    // deactivate listeners
    this.$root.$off('bv::modal::hidden', () => {
      this.init()
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.selected = JSON.parse(JSON.stringify(this.preselected))
      this.commentConfig = this.selected.map(status => {
        const existing = this.preselectedCommentConfig.find(c => c.value === status.value)
        return existing ? { ...existing } : { value: status.value, commentsEnabled: false }
      })
    },
    isCommentsEnabled(value) {
      const entry = this.commentConfig.find(c => c.value === value)
      return entry ? entry.commentsEnabled : false
    },
    removeStatus({ value }) {
      const index = this.selected.findIndex(selection => selection.value === value)
      this.selected.splice(index, 1)
      this.commentConfig = this.commentConfig.filter(c => c.value !== value)
    },
    toggleComments(value) {
      const entry = this.commentConfig.find(c => c.value === value)
      if (entry) {
        entry.commentsEnabled = !entry.commentsEnabled
      } else {
        this.commentConfig.push({ value, commentsEnabled: true })
      }
    },
    handleInput({ value }) {
      const match = this.selected.find(selection => selection.value === value)
      if (match) return

      this.selected.push({
        value,
        label: this.$i18n.t(
          `participationPanel.options.statusStations.regularLabels.${value}`,
        ),
      })
      this.commentConfig.push({ value, commentsEnabled: false })
    },
    handleSubmit() {
      this.$emit('select', { selected: this.selected, commentConfig: this.commentConfig })
    },
  },
}
</script>

<style lang="scss">
.modal {
  &__select-statuses {
    &__active-statuses {
      min-width: 250px;
      border-right: 1px solid var(--border-color)
    }
    &__status-selector {
      max-width: 250px;
    }
  }
}
</style>
